import React from "react";
import Sidebar from "../Admin/Sidebar";

const loans = [
  {
    id: 1,
    borrower: "Tola Dabalaa",
    amount: "50,000",
    term: "12 months",
    status: "Approved",
    createdAt: "2026-02-01",
  },
  {
    id: 2,
    borrower: "Debali chala",
    amount: "22,500",
    term: "6 months",
    status: "Pending",
    createdAt: "2026-02-15",
  },
];

function ViewLoan() {
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
    

      {/* Main Content */}
      <div className="flex-1 p-6 ml-8 lg:ml-24">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">
            Loan Management
          </h1>
          <button className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
            + Add Loan
          </button>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100 text-gray-700 uppercase">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Borrower</th>
                <th className="px-6 py-3">Amount</th>
                <th className="px-6 py-3">Term</th>
                <th className="px-6 py-3">Status</th>
                <th className="px-6 py-3">Created At</th>
                <th className="px-6 py-3 text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loans.map((loan, index) => (
                <tr
                  key={loan.id}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="px-6 py-4 text-teal-400">{index + 1}</td>
                  <td className="px-6 py-4 font-medium text-teal-400">
                    {loan.borrower}
                  </td>
                  <td className="px-6 py-4 text-teal-400">{loan.amount}</td>
                  <td className="px-6 py-4 text-teal-400" text-teal-400>{loan.term}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${{
                        Approved: "bg-green-100 text-green-700",
                        Pending: "bg-yellow-100 text-yellow-700",
                        Rejected: "bg-red-100 text-red-700",
                      }[loan.status]}`}
                    >
                      {loan.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-teal-400">{loan.createdAt}</td>
                  <td className="px-6 py-4 text-center space-x-2">
                    <button className="text-blue-600 hover:underline">
                      Edit
                    </button>
                    <button className="text-red-600 hover:underline">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ViewLoan;
